import { render } from "./NotariesList.vue?vue&type=template&id=59b1f176&scoped=true"
import script from "./NotariesList.vue?vue&type=script&lang=js"
export * from "./NotariesList.vue?vue&type=script&lang=js"

import "./NotariesList.vue?vue&type=style&index=0&id=59b1f176&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b1f176"]])

export default __exports__